import { v1 as uuid } from 'uuid';
import axios from 'axios';
import { parse } from 'query-string';
import { WORKFLOW_ROOT } from '../../config/api';

const workFlowActions = {
  RESTART: 'WORKFLOW_RESTART',
  RESTART_FAILED: 'WORKFLOW_RESTART_FAILED',
  RESTART_SUCCESS: 'WORKFLOW_RESTART_SUCCESS',
  START: 'WORKFLOW_START',
  START_FAILED: 'WORKFLOW_START_FAILED',
  START_SUCCESS: 'WORKFLOW_START_SUCCESS',

  getRequest: (deviceToken) => {
    const searchParams = parse(window.location.search);
    let browserSessionToken = sessionStorage.getItem('browserSessionToken');

    if (!browserSessionToken) {
      const token = uuid();
      sessionStorage.setItem('browserSessionToken', token);
      browserSessionToken = token;
    }
    const source = searchParams.of_source || searchParams.utm_source || searchParams.ml_source;
    const medium = searchParams.of_medium || searchParams.utm_medium || searchParams.ml_medium;
    const term = searchParams.of_term || searchParams.utm_term || searchParams.ml_term;
    const content = searchParams.of_content || searchParams.utm_content || searchParams.ml_content;
    const campaign =
      searchParams.of_campaign || searchParams.utm_campaign || searchParams.ml_campaign;
    const {
      appRequestId,
      emailToken,
      existing,
      market,
      // eslint-disable-next-line camelcase
      oauth_state_id,
      origin,
      page,
      prefillToken,
      product,
      resendEmailToken,
      retargetSource,
      retargetEmailCount,
      restart,
      t: token,
    } = searchParams;
    const searchParamsState = {
      appRequestId,
      browserSessionToken,
      campaign,
      content,
      deviceToken,
      emailToken,
      existing,
      market,
      medium,
      oauth_state_id,
      origin,
      page,
      prefillToken,
      product,
      resendEmailToken,
      retargetSource,
      retargetEmailCount,
      restart,
      source,
      term,
      token,
    };

    return {
      request: () => axios.post(`${WORKFLOW_ROOT}/start`, searchParamsState),
      searchParamsState,
    };
  },
  getRestartRequest: (payload) => () => axios.post(`${WORKFLOW_ROOT}/restart`, payload),

  restart: (payload) => ({
    payload,
    type: workFlowActions.RESTART,
  }),

  restartFailed: (data) => ({
    payload: { data },
    type: workFlowActions.RESTART_FAILED,
  }),

  restartSuccess: (data) => ({
    payload: { data },
    type: workFlowActions.RESTART_SUCCESS,
  }),

  startSuccess: (data, searchParams = {}) => ({
    payload: { data, searchParams },
    type: workFlowActions.START_SUCCESS,
  }),
};

export default workFlowActions;
